import { createSelector } from 'reselect';

import { getParams, getUIDetails } from './general';

const getFieldsItem = createSelector(getUIDetails, details => details.fields);

export const getFields = createSelector(getFieldsItem, fields => fields.data);

export const getFieldForQuestion = createSelector(getFields, getParams, (fields, question) => fields?.[question]);
